module.exports = __webpack_public_path__ + "static/media/2_en.eb1d9e5a.png";